import React from 'react';
import Alert from 'react-bootstrap/Alert';
import { t } from '../../../../../i18n';

const PaymentSuccessInstructions = () => (
  <Alert variant="info">
    <b>{t('DIGITAL_COURSES.CHECKOUT.PURCHASE_RESULT.SUCCESS.NOTE_TITLE')}</b>
    {t('DIGITAL_COURSES.CHECKOUT.PURCHASE_RESULT.SUCCESS.NOTE_BODY')}
  </Alert>
);

export default PaymentSuccessInstructions;
